export const getDealCroppedImg = (
  imageSrc,
  croppedAreaPixels,
  targetWidth = 1000 // default width
) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = imageSrc;
    image.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      // ✅ enforce 2.5:3 aspect ratio
      const aspectWidth = 2.5;
      const aspectHeight = 3;

      // auto-calc height based on aspect
      const targetHeight = Math.round(targetWidth * (aspectHeight / aspectWidth));

      canvas.width = targetWidth;
      canvas.height = targetHeight;

      ctx.drawImage(
        image,
        croppedAreaPixels.x,
        croppedAreaPixels.y,
        croppedAreaPixels.width,
        croppedAreaPixels.height,
        0,
        0,
        targetWidth,
        targetHeight
      );

      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error("Canvas is empty"));
          return;
        }
        resolve(blob);
      }, "image/jpeg", 1);
    };

    image.onerror = (err) => reject(err);
  });
};
